<template>
  <el-dialog
    title="Criar Diretório"
    :visible.sync="visibility"
    :before-close="fechar"
    :modal-append-to-body="false"
    @open="reset"
    width="35%"
  >
    <el-form size="small" label-position="top">
      <el-form-item label="Nome Diretório">
        <el-input v-model="nome"/>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="criarDiretorio()" type="primary" size="small">Criar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  props: {
    visibility: Boolean,
    tipo: String
  },
  data() {
    return {
      nome: ""
    };
  },
  computed: {
    ...mapState("imoveisStore", {
      imovel(state) { return state.imovelSelecionado; }
    }),
    ...mapState("vendasStore", {
      venda(state) { return state.vendaSelecionada; }
    })
  },
  methods: {
    ...mapActions(["showLoading", "hideLoading"]),
    ...mapActions("imoveisStore", ["criarDiretorioImovel"]),
    ...mapActions("vendasStore", ["criarDiretorioVenda"]),
    criarDiretorio() {
      switch(this.tipo) {
      case "VENDA":
        this.requestVenda();
        break;
      case "IMOVEL_VENDA":
        this.requestImovel();
        break;
      }
    },
    requestImovel() {
      let payload = {
        idObjeto: this.imovel.id,
        tipoFormularios: this.tipo,
        nome: this.nome
      };

      this.showLoading();
      this.criarDiretorioImovel(payload)
      .then(resultado => {
        switch (resultado.status) {
        case "SUCESSO":
          this.$message.success(resultado.mensagem);
          this.fechar();
          break;
        case "FALHA":
        case "ERRO":
          this.$message.error(resultado.mensagem);
        }

        this.hideLoading();
      }).catch(() => {
        this.$message.error("Ocorreu um erro.");
        this.hideLoading();
      });
    },
    requestVenda() {
      let payload = {
        idObjeto: this.venda.id,
        tipoFormularios: this.tipo,
        nome: this.nome
      };

      this.showLoading();
      this.criarDiretorioVenda(payload)
      .then(resultado => {
        switch (resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.fechar();
            break;
          case "FALHA":
          case "ERRO":
            this.$message.error(resultado.mensagem);
        }

        this.hideLoading();
      }).catch(() => {
        this.$message.error("Ocorreu um erro.");
        this.hideLoading();
      });
    },
    reset() {
      this.nome = "";
    },
    fechar() {
      this.$emit("close");
    }
  }
};
</script>

